var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99023 22.57V10.1408C1.99023 9.77471 2.07222 9.42819 2.23619 9.1012C2.40016 8.77422 2.62609 8.50491 2.91399 8.29327L10.6143 2.46188C11.0176 2.15396 11.478 2 11.9957 2C12.5133 2 12.9766 2.15396 13.3856 2.46188L21.086 8.29184C21.3748 8.50348 21.6008 8.77326 21.7638 9.1012C21.9277 9.42819 22.0097 9.77471 22.0097 10.1408V22.57C22.0097 22.9533 21.8672 23.2874 21.5822 23.5724C21.2971 23.8575 20.963 24 20.5798 24H15.7408C15.4128 24 15.1383 23.8894 14.9171 23.6682C14.6959 23.4461 14.5854 23.1716 14.5854 22.8446V16.0251C14.5854 15.6981 14.4748 15.424 14.2536 15.2029C14.0315 14.9807 13.7569 14.8697 13.4299 14.8697H10.57C10.243 14.8697 9.96896 14.9807 9.74779 15.2029C9.52567 15.424 9.41461 15.6981 9.41461 16.0251V22.846C9.41461 23.173 9.30402 23.4471 9.08286 23.6682C8.86169 23.8894 8.58761 24 8.26063 24H3.4202C3.03697 24 2.70283 23.8575 2.41779 23.5724C2.13275 23.2874 1.99023 22.9533 1.99023 22.57Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseFilled);
export default __webpack_public_path__ + "static/media/house-filled.894e76fbaeb49d7325aa520f06c90485.svg";
export { ForwardRef as ReactComponent };